import { alertsStore } from "../store";

export const closeAlert = () => {
  alertsStore.show = false;
};
